import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/magic-swap/app/error.tsx");
